import { render, staticRenderFns } from "./PostReport.vue?vue&type=template&id=0c972f3d&scoped=true"
import script from "./PostReport.vue?vue&type=script&lang=js"
export * from "./PostReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c972f3d",
  null
  
)

export default component.exports